import {ButtonConverter} from '@mintdata/mint-components/components/button/ButtonConverter';
import {ButtonEditor} from '@mintdata/mint-components/components/button/ButtonEditor';
import {ButtonModel} from '@mintdata/mint-components/components/button/ButtonModel';
import {IPropertyTypeConfig} from '@mintdata/mint-kit/api/properties/PropertyTypeConfig';

export const ButtonConfig:IPropertyTypeConfig<ButtonModel> =
    {
        converter: ButtonConverter,
        editor: ButtonEditor,
    };
